import { useState, useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useUpdateSeAccessMutation } from "Services/AdminService";
import ReactCountryFlag from "react-country-flag"
import { WelcomeMessagePopup } from 'views/welcome-message';
import { Quill } from 'react-quill';
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    ClickAwayListener,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Typography,
    Backdrop,
    CircularProgress,
    Collapse,
    Tooltip,
    Badge,
    ButtonBase,
    
} from '@mui/material';
// third-party

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import RateReviewIcon from '@mui/icons-material/RateReview';
import FeedbackForm from './FeedbackForm';
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import IconPerson from '@mui/icons-material/Person'
import RockerLaunchIcon from "@mui/icons-material/RocketLaunch";
import QuillResize from 'quill-resize-module';

// assets
import { IconLogout } from '@tabler/icons';

import { useLogoutMutation } from 'Services/LoginServices';
import { showSuccessToaster } from 'store/Shared.Slice';

import { useTranslation } from "react-i18next";
import { EventOutlined, FeedbackOutlined, HelpOutline, Person } from '@mui/icons-material';
import { HELP_CENTER_URL } from 'utils/constants';
import ReferralFormPopup from '../ReferralSection/ReferralForm.Popup';

// ==============================|| PROFILE MENU ||============================== //
Quill.register('modules/resize', QuillResize);
const SimpleProfileSection = () => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const { userToken, subscriptionInfo } = useSelector(state => state.sharedState);
    const dispatch = useDispatch();
    const [UpdateAccess, { isLoading: isUpdatingAccess }] = useUpdateSeAccessMutation();
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [openWelcomeMessage, setOpenWelcomeMessage] = useState(false);

    const validRoles = ["Admin", "Sales", "SuperAdmin"];
    const { t } = useTranslation();
    let userRoles = [];

    if (Array.isArray(userToken?.role)) {
        userRoles = userToken?.role ?? ['User'];
    }
    else {
        userRoles.push(userToken?.role ?? 'User');
    }
    const substring = "AccessUs";
    
    const accessUs = userRoles.filter((string) =>
      string.toUpperCase().includes(substring.toUpperCase())
    );
    
    const accessCanada = userRoles.filter((string) =>
      string.toUpperCase().includes("AccessCanada".toUpperCase())
    );
    
    const [selectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [openFeedback, setFeedbackOpen] = useState(false);

    const defaultFormValue = {
        nameCharity: { value: "", error: "" },
        nameContact: { value: "", error: "" },
        email: { value: "", error: "" },
        phoneNumber: { value: "", error: "" },
        success: { value: "", error: "" },
    };
    const [formValue, setFormValue] = useState(defaultFormValue);

    const [openPopupReferral, setOpenPopupReferral] = useState(false);

    const handleOpenPopupReferral = () => {
        setFormValue(defaultFormValue);
        setOpenPopupReferral(true);
        setOpenWelcomeMessage(false)
    };

    const handleClosePopupReferral = () => {
        setOpenPopupReferral(false);
    };
    
    const [logout, { isLoading }] = useLogoutMutation();

    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const anchorFeedbackRef = useRef(null);

    const handleLogout = async () => {
        handleToggle();
        const responseLogout = await logout().unwrap();
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        navigate('/', { replace: true });
        dispatch(showSuccessToaster(responseLogout.message));
    };

    const handleUserProfile = async () => {
        handleToggle();
        navigate('/main/account/user-profile', { replace: true });
    };

    const handleChangeAccess = async () => {
        
        if (validRoles.some(role => userRoles.includes(role))) {
            const response = await UpdateAccess().unwrap();

            handleToggle();
            const responseLogout = await logout().unwrap();
            localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
            navigate('/', { replace: true });
            dispatch(showSuccessToaster(responseLogout.message));
        } 
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleFeedbackClose = (event) => {
        if (anchorFeedbackRef.current && anchorFeedbackRef.current.contains(event.target)) {
            return;
        }
        setExpandedIndex(null);
        setFeedbackOpen(false);
    };

    const handleFeedbackSubmitted = () => {
        setFeedbackOpen(false);
        setExpandedIndex(null);
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleFeedbackToggle = () => {
        setFeedbackOpen((prevFeedbackOpen) => !prevFeedbackOpen);
    };

    const handleExpandClick = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const prevOpen = useRef(open);
    const prevFeedbackOpen = useRef(openFeedback);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;

        if (prevFeedbackOpen.current === true && openFeedback === false) {
            anchorFeedbackRef.current.focus();
        }

        prevFeedbackOpen.current = openFeedback;

    }, [open, openFeedback]);

    const openInNewTab = url => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    };

    return (
        <>
            <ButtonBase sx={{borderRadius: '12px'}} >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light :theme.palette.secondary.main,
                        width: '45px',
                        height: '45px',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.dark :theme.palette.secondary.light
                        }
                    }}
                    color="inherit"
                    onClick={() => handleChangeAccess()}
                >
                    {accessUs.length > 0 && (
                        <ReactCountryFlag
                            countryCode="US"
                            svg
                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                            cdnSuffix="svg"
                            title="US"
                        />
                    )}

                    {accessCanada.length > 0 && (
                        <ReactCountryFlag
                            countryCode="CA"
                            svg
                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                            cdnSuffix="svg"
                            title="CA"
                        />
                    )}
                </Avatar>
            </ButtonBase>

            <ButtonBase sx={{borderRadius: '12px', marginLeft: '23px'}} >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light :theme.palette.secondary.main,
                        width: '45px',
                        height: '45px',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.dark :theme.palette.secondary.light
                        }
                    }}
                    color="inherit"
                    onClick={() => handleFeedbackToggle()}
                >
                    <Tooltip title={t('labels.feedback')}>
                        <FeedbackOutlined
                            aria-label="Feedback"
                            sx={{
                                ...theme.typography.mediumFeedback,
                                marginRight: '14px!important',
                                marginLeft: '12px!important',
                                cursor: 'pointer',
                                color: "secondary.main"
                            }}
                            ref={anchorFeedbackRef}
                            aria-controls={openFeedback ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                        />
                    </Tooltip>
                   
                </Avatar>
            </ButtonBase>

           
            <Popper
                placement="bottom-end"
                open={openFeedback}
                anchorEl={anchorFeedbackRef.current}
                role={undefined}
                transition
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={openFeedback} {...TransitionProps} >
                        <Paper>
                            <ClickAwayListener onClickAway={handleFeedbackClose}>
                                <MainCard sx={{ 
                                        maxWidth: 417, 
                                        maxHeight: "90vh", 
                                        overflow: "auto",
                                    }} 
                                border={false} 
                                elevation={16} 
                                content={false}
                                boxShadow 
                                shadow={theme.shadows[16]}
                            >
                                    <Box sx={{ p: 3 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography variant="h5">Classify your feedback</Typography>
                                               
                                            </Stack>
                                        </Stack>
                                        <Divider />
                                    </Box>
                                    <Box sx={{ pl: 2, pr: 2, mt: -2 }}>
                                        <List
                                            component="nav"
                                            backgroundColor= {theme.palette.background.default}
                                            sx={{
                                                width: '100%',
                                                maxWidth: 900,
                                                minWidth: 380,
                                                backgroundColor: theme.palette.background.default,
                                                borderRadius: '10px',
                                                [theme.breakpoints.down('md')]: {
                                                    minWidth: '100%'
                                                }
                                            }}
                                        >
                                            
                                            {/*-------- Compliment --------*/}
                                            <ListItemButton
                                                backgroundColor= {theme.palette.background.default}
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 0}
                                                onClick={() => handleExpandClick(0)}
                                            >
                                                <ListItemIcon>
                                                    <FavoriteIcon color='secondary' stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">Give a compliment</Typography>} />
                                            </ListItemButton>


                                            <Collapse in={expandedIndex === 0} timeout="auto" unmountOnExit>
                                                <FeedbackForm 
                                                    question="What did you like? *"
                                                    feedbackType="Compliment"
                                                    showGivePermission
                                                    onSubmit={handleFeedbackSubmitted}
                                                    onCancel={() => setExpandedIndex(null)}
                                                />
                                            </Collapse>

                                            {/*-------- Issue --------*/}
                                            <ListItemButton
                                                backgroundColor= {theme.palette.background.default}
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 1} 
                                                onClick={() => handleExpandClick(1)}
                                            >
                                                <ListItemIcon>
                                                    <AssignmentLateIcon color='secondary' stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">Report a problem</Typography>} />
                                            </ListItemButton>
                                            <Collapse in={expandedIndex === 1} timeout="auto" unmountOnExit>
                                                <FeedbackForm 
                                                    question="What went wrong? *"
                                                    feedbackType="Issue"
                                                    showUploadScreenshots
                                                    onSubmit={handleFeedbackSubmitted}
                                                    onCancel={() => setExpandedIndex(null)}
                                                />
                                            </Collapse>

                                            {/*-------- Suggeston --------*/}
                                            <ListItemButton
                                                backgroundColor= {theme.palette.background.default}
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 2} 
                                                onClick={() => handleExpandClick(2)}
                                            >
                                                <ListItemIcon>
                                                    <RateReviewIcon color='secondary' stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">Make a suggestion</Typography>} />
                                            </ListItemButton>
                                            <Collapse in={expandedIndex === 2} timeout="auto" unmountOnExit>
                                                <FeedbackForm 
                                                    question="How can we improve? *"
                                                    feedbackType="Suggestion"
                                                    showUploadScreenshots
                                                    onSubmit={handleFeedbackSubmitted}
                                                    onCancel={() => setExpandedIndex(null)}
                                                />
                                            </Collapse>

                                            {/*-------- Success --------*/}
                                            

                                        </List>
                                    </Box>
                                 </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>

            <ButtonBase sx={{borderRadius: '12px', marginLeft: '23px'}} >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.light :theme.palette.secondary.main,
                        width: '45px',
                        height: '45px',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.dark :theme.palette.secondary.light
                        }
                    }}
                    color="inherit"
                    onClick={() => openInNewTab(HELP_CENTER_URL)}
                >
                    <Tooltip title={t('labels.help_center')}>
                        <HelpOutline  
                            sx={{
                                color: theme.palette.mode === 'dark' ? 'secondary.dark' : 'secondary.main!important',
                                background: theme.palette.mode === 'dark' ? 'secondary.dark' : 'secondary.main!important',
                                width: '1.4em',
                                height: '1.4em'
                            }}
                        />
                    </Tooltip>
                    
                    
                   
                </Avatar>
            </ButtonBase>

            <Backdrop
                sx={{ color: '#fff', zIndex: 1 }}
                open={isLoading || isUpdatingAccess}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ButtonBase 
                sx={{ 
                    marginLeft: '23px',
                    '&[aria-controls="menu-list-grow"], &:hover, &:focus': {
                        color: theme.palette.secondary.light,
                        '& svg': {
                            stroke: theme.palette.secondary.light
                        }
                    },
                }}
                onClick={handleToggle}
            >
                <Tooltip title={t('labels.user_profile')}>
                    <Avatar
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    >
                        <Person sx={{ color: 'white' }} />
                    </Avatar>
                </Tooltip>
            </ButtonBase>
             
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ p: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" marginRight="18px">
                                                <div style={{ display: "flex" }}>
                                                    <Typography variant="h4">{t('labels.hi')},&nbsp;</Typography>
                                                    <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                        {userToken.UserName}
                                                    </Typography>
                                                </div>
                                                <div>
                                                 <Tooltip title={`${subscriptionInfo?.daysLeft} days left to expire`}>
                                                    <Badge 
                                                        badgeContent={subscriptionInfo?.daysLeft}
                                                        max={subscriptionInfo?.daysLeft + 10}
                                                        color={
                                                            subscriptionInfo?.daysLeft <= 10 ? 'error' :
                                                            subscriptionInfo?.daysLeft <= 30 ? 'warning' : 
                                                            'primary'
                                                        }>
                                                            <EventOutlined color="action" />
                                                    </Badge>
                                                </Tooltip>
                                                </div>
                                            </Stack>
                                        </Stack>
                                        <Divider />
                                    </Box>
                                    <Box sx={{ pl: 2, pr: 2, mt: -2 }} aria-label="Logout">
                                        <List
                                            component="nav"
                                            sx={{
                                                width: '100%',
                                                maxWidth: 350,
                                                minWidth: 300,
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: '10px',
                                                [theme.breakpoints.down('md')]: {
                                                    minWidth: '100%'
                                                },
                                                
                                            }}
                                        >
                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 4}
                                                onClick={handleUserProfile}
                                            >
                                                <ListItemIcon>
                                                    <IconPerson stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">{t('labels.user_profile')}</Typography>} />
                                            </ListItemButton>


                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 4}
                                                onClick={() => setOpenWelcomeMessage(true)}
                                                data-testid="get-started-menu-item"
                                            >
                                                <ListItemIcon>
                                                    <RockerLaunchIcon stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">Get Started</Typography>} />
                                            </ListItemButton>


                                            <ListItemButton
                                                sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                selected={selectedIndex === 5}
                                                onClick={handleLogout}
                                            >
                                                <ListItemIcon>
                                                    <IconLogout stroke={1.5} size="20" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">{t('labels.logout')}</Typography>} />
                                            </ListItemButton>

                                        </List>
                                    </Box>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>

            <WelcomeMessagePopup 
                open={openWelcomeMessage} 
                onClose={() => setOpenWelcomeMessage(false)} 
                showCloseButton={true}
                onClickOpenReferralPopup={handleOpenPopupReferral}
            />
            <ReferralFormPopup
                openPopup={openPopupReferral}
                onClose={handleClosePopupReferral}
                width="600px"
                height="400px"
                formValue={formValue}
                setFormValue={setFormValue}
            />
        </>
    );
};

export default SimpleProfileSection;
